import Api from '@/services/http'
import type { PaginationType, WalletListType } from '@/store/walletSlice/types'
import type * as Types from './type'

/**
 * 获取预占流水列表
 * @param params
 * @returns
 */
export const fetchPreemptList = async (params: PaginationType) => {
  const res = await Api.admin.post('/api/wallet/flow/preempt/list', params)
  return res.data
}

/**
 * 获取钱包流水列表
 * @param params
 * @returns
 */
export const fetchWalletList = async (params: WalletListType & PaginationType) => {
  const res = await Api.admin.post<Types.FlowListRes>('/api/wallet/flow/list', params)
  return res.data
}

/**
 * 查询充值套餐信息
 * @returns
 */
export const postRechargeInfo = (param: Types.RechargeInfoParams) => Api.admin.post<Types.RechargeInfoRes>('/api/pay/recharge_info', param)

/**
 * 查询内部支付状态
 * @returns
 */
export const postPayStatus = (params: Types.GetPayStatusReq) => Api.admin.post<Types.GetPayStatusRes>('/api/crm/admin/subscription/pay/get-pay-status', params)

/**
 * 创建支付
 * @returns
 */
export const postCreateWalletPay = (packageSeq: string) => Api.admin.post<Types.PayCreateRes>('/api/crm/admin/subscription/pay/create', { packageSeq })

/** 获取支付方式和对应的支付平台 */
export const getPayChannelList = (params: { countryCode: string; currencyCode: string }) => Api.admin.post('/api/crm/admin/pay/pay-channel-list', params)

/** 获取账单信息 */
export const getSettlement = (params: { packageSeqList: string[] }) => Api.admin.post('/api/pay/settlement', params)

/** 创建订单 */

export const createPayBill = (params) => Api.admin.post('/api/crm/admin/pay/create', params)
/**
 * 导出钱包流水
 * @param params
 * @returns
 */
export const postWalletFlowExport = (params: WalletListType & PaginationType) => Api.toast.post('/api/wallet/flow/export', params)

/**
 * 退订/重新订阅
 * @param params
 * @returns
 */
export const walletSubscribeSetting = (params: Types.SubscribeType) => Api.toast.post('/api/wallet/monitor/subscribe/setting', params)

/**
 * 保存钱包余额监控设置
 * @param params
 * @returns
 */
export const walletMonitorSettingSave = (params: Types.BalanceThresholdParams) => Api.toast.post('/api/wallet/monitor/setting/save', params)

/**
 * 查询钱包余额监控设置
 * @param params
 * @returns
 */
export const walletMonitorSettingGet = () => Api.toast.post<{ walletMonitorSettingBos: Types.BalanceThresholdParams[] }>('/api/wallet/monitor/setting/get')
